import * as constants from "./constants";

const initialState = {
  allTemplates: [],
  createTemplateLoading: false,
  currentTemplateObj: {
    name: "",
    fields: [],
  },
  templateCreatedSuccess: false,
  templateEditSuccess: false,
  // fetchingLoading: false,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
  fetchTemplateLoading: false,
  materialTemplateIsEdit: false,
  deleteTemplateLoading: false,
};

const materialTemplatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.MATERIAL_TEMPLATE_IS_EDIT:
      return {
        ...state,
        materialTemplateIsEdit: action.data,
      };
    case constants.CREATE_TEMPLATE:
      return {
        ...state,
        templateEditSuccess: false,
        createTemplateLoading: true,
        templateCreatedSuccess: false,
        materialTemplateIsEdit: false,
      };
    case constants.CREATE_TEMPLATE_SUCCESS:
      console.log("CREATE_TEMPLATE_SUCCESS action.data:", action.data);
      // Safely handle cases where fields or options might be undefined
      const templateFields = Array.isArray(action.data.fields) 
        ? action.data.fields.map((el) => ({
            ...el,
            isEdit: false,
            isLocal: false,
            options: Array.isArray(el.options) 
              ? el.options.map((ele) => ({
                  ...ele,
                  isEdit: false,
                  isLocal: false,
                }))
              : []
          }))
        : [];
      
      console.log("Processed templateFields:", templateFields);

      return {
        ...state,
        createTemplateLoading: false,
        materialTemplateIsEdit: false,
        templateCreatedSuccess: true,
        templateEditSuccess: false,
        currentTemplateObj: {
          ...action.data,
          fields: templateFields,
        },
      };
    case constants.CREATE_TEMPLATE_ERROR:
      return {
        ...state,
        createTemplateLoading: false,
        templateCreatedSuccess: false,
      };
    case constants.FETCH_ALL_TEMPLATES:
      return {
        ...state,
        fetchTemplateLoading: true,
        templateCreatedSuccess: false,
        templateEditSuccess: false,
      };
    case constants.FETCH_ALL_TEMPLATES_SUCCESS:
      const { allTemplates, totalRecords } = action.data;
      return {
        ...state,
        fetchTemplateLoading: false,
        isAdding: false,
        allTemplates,
        totalRecords,
        templateCreatedSuccess: false,
        materialTemplateIsEdit: false,
        templateEditSuccess: false,
      };
    case constants.FETCH_ALL_TEMPLATES_ERROR:
      return {
        ...state,
        fetchTemplateLoading: false,
        isAdding: false,
        templateCreatedSuccess: false,
        templateEditSuccess: false,
      };
    case constants.UPDATE_TEMPLATE:
      return {
        ...state,
        updateLoading: true,
        templateCreatedSuccess: false,
      };
    case constants.UPDATE_TEMPLATE_SUCCESS:
      // const updated = state.allTemplates.map((el) =>
      //   el.id === action.data.id ? { ...el, ...action.data } : el
      // );
      return {
        ...state,
        // allTemplate: updated,
        updateLoading: false,
        isAdding: false,
        templateCreatedSuccess: false,
        materialTemplateIsEdit: false,
        templateEditSuccess: true,
      };
    case constants.UPDATE_TEMPLATE_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
        templateCreatedSuccess: false,
      };
    case constants.DELETE_TEMPLATE:
      return {
        ...state,
        templateEditSuccess: false,
        deleteTemplateLoading: true,
        templateCreatedSuccess: false,
        materialTemplateIsEdit: false,
      };
    case constants.DELETE_TEMPLATE_SUCCESS:
      return {
        ...state,
        deleteTemplateLoading: false,
      };
    case constants.DELETE_TEMPLATE_ERROR:
      return {
        ...state,
        fetchTemplatesLoading: false,
      };

    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };
    case constants.FETCH_TEMPLATE:
      return {
        ...state,
        fetchTemplateLoading: true,
        templateCreatedSuccess: false,
      };
    case constants.FETCH_TEMPLATE_SUCCESS:
      const { fields = [] } = action.data; // Initialize with empty array if undefined
      const updatedTemplateFields = fields.map((el) => ({
        ...el,
        isEdit: false,
        isLocal: false,
        options: el.options?.map((ele) => ({  // Use optional chaining for options
          ...ele,
          isEdit: false,
          isLocal: false,
        })) || [],  // Initialize with empty array if no options
      }));

      return {
        ...state,
        fetchTemplateLoading: false,
        templateCreatedSuccess: false,
        currentTemplateObj: {
          ...action.data,
          fields: updatedTemplateFields,
        },
      };
    case constants.FETCH_TEMPLATE_ERROR:
      return {
        ...state,
        fetchTemplateLoading: false,
        templateCreatedSuccess: false,
      };
    // default:
    //   return state;
    case constants.TEMPLATE_CREATION_CLEANUP_FUNC:
      return {
        ...state,
        allTemplates: [],
        createTemplateLoading: false,
        currentProjectObj: {},
        templateDetailsIsEdit: false,
        fetchTemplateLoading: false,
        deletePTemplateLoading: false,
        templateEditSuccess: false,
        currentTemplateObj: {
          template_type: "ims",
          name: "",
          numbering_mask: "",
          turnaround_time: false,
          completion_days: "",
          revision_control: false,
          distribution_control: false,
          fields: [],
        },
        // projectNotificationIsEdit: false,
      };
    default:
      return state;
  }
};

export default materialTemplatesReducer;
